const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaCliente: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'WHATSAPP_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'WHATSAPP_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'WHATSAPP_CLIENTE_LISTADO':
			return {
				...state,
				listaCliente: action.payload.data
            };

        default:
            return state;
    }
}
